import _Vue from 'vue';
import VueI18n from 'vue-i18n';

class WxI18nPlugin {
    private xInstance: any;

    public instance() {
        return this.xInstance;
    }

    public install(Vue: typeof _Vue, options: any) {
        Vue.use(VueI18n);

        const instance = new VueI18n({
            locale: options.locale || 'xx',
            fallbackLocale: options.fallbackLocale || 'def',
            silentFallbackWarn: options.silentFallbackWarn || true,
            silentTranslationWarn: options.silentTranslationWarn || true,
            missing: (locale: string, key: string) => {
                return key.charAt(0) === '$' ? '{' + key.split('.').pop() + '}' : key;
            },
        });

        const vm = new Vue({
            data: { i18n: instance },
            computed: {
                localResource: function () {
                    return options.localeResource();
                },
            },
            watch: {
                localResource: {
                    handler(val: any) {
                        this.i18n.setLocaleMessage('xx', val);
                    },
                    deep: true,
                    immediate: true,
                },
            },
        });

        this.xInstance = instance;
    }
}

export { WxI18nPlugin };
